import { computed } from 'vue'
import { useI18n } from '~/composables/useI18n'

export type MusicStyleTag = {
    value: string
    label: string
}

/**
 * Music tag catalog (genre / emotion / instrument)
 * Shared by:
 * - components/Tool/PromptWithTags.vue
 * - components/Tool/workbench/WorkbenchDynamicGroups.vue (voice_tags popover)
 */
export function useMusicTagCatalog() {
    const { t } = useI18n()

    const genreStyleTags = computed<MusicStyleTag[]>(() => [
        { value: 'POP', label: t('menus.musicStyles.POP') },
        { value: 'ROCK', label: t('menus.musicStyles.ROCK') },
        { value: 'RAP', label: t('menus.musicStyles.RAP') },
        { value: 'ELECTRONIC', label: t('menus.musicStyles.ELECTRONIC') },
        { value: 'RNB', label: t('menus.musicStyles.RNB') },
        { value: 'JAZZ', label: t('menus.musicStyles.JAZZ') },
        { value: 'FOLK', label: t('menus.musicStyles.FOLK') },
        { value: 'CLASSIC', label: t('menus.musicStyles.CLASSIC') },
        { value: 'WORLD', label: t('menus.musicStyles.WORLD') },
    ])

    const emotionStyleTags = computed<MusicStyleTag[]>(() => [
        { value: 'HAPPY', label: t('menus.musicEmotions.HAPPY') },
        { value: 'RELAXED', label: t('menus.musicEmotions.RELAXED') },
        { value: 'WARM', label: t('menus.musicEmotions.WARM') },
        { value: 'ROMANTIC', label: t('menus.musicEmotions.ROMANTIC') },
        { value: 'TOUCHING', label: t('menus.musicEmotions.TOUCHING') },
        { value: 'SAD', label: t('menus.musicEmotions.SAD') },
        { value: 'LONELY', label: t('menus.musicEmotions.LONELY') },
        { value: 'DEPRESSED', label: t('menus.musicEmotions.DEPRESSED') },
        { value: 'TENSE', label: t('menus.musicEmotions.TENSE') },
        { value: 'EXCITED', label: t('menus.musicEmotions.EXCITED') },
        { value: 'EPIC', label: t('menus.musicEmotions.EPIC') },
        { value: 'MYSTERIOUS', label: t('menus.musicEmotions.MYSTERIOUS') },
    ])

    const instrumentStyleTags = computed<MusicStyleTag[]>(() => [
        { value: 'PIANO', label: t('menus.musicInstruments.PIANO') },
        { value: 'GUITAR', label: t('menus.musicInstruments.GUITAR') },
        { value: 'BASS', label: t('menus.musicInstruments.BASS') },
        { value: 'DRUMS', label: t('menus.musicInstruments.DRUMS') },
        { value: 'STRINGS', label: t('menus.musicInstruments.STRINGS') },
        { value: 'WIND', label: t('menus.musicInstruments.WIND') },
        { value: 'SYNTHESIZER', label: t('menus.musicInstruments.SYNTHESIZER') },
        {
            value: 'ELECTRONIC_SOUND',
            label: t('menus.musicInstruments.ELECTRONIC_SOUND'),
        },
        {
            value: 'FOLK_INSTRUMENT',
            label: t('menus.musicInstruments.FOLK_INSTRUMENT'),
        },
        {
            value: 'MIXED_ORCHESTRATION',
            label: t('menus.musicInstruments.MIXED_ORCHESTRATION'),
        },
    ])

    return {
        genreStyleTags,
        emotionStyleTags,
        instrumentStyleTags,
    }
}

